import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar/Navbar'
import { Link, useParams } from 'react-router-dom'
import "./DetailEnroll.css"
import { useGetSingleByAgeAndGenderQuery } from '../../../Redux/Api/AuthApi'
import { useDispatch } from 'react-redux'
import { detailsEnroll } from '../../../Redux/Slice/AuthSlice'

const DetailEnroll = () => {
  const [resData,setResData] = useState()
  const [errMsg,setErrMsg] = useState()
  const { id } = useParams();
  const dispatch = useDispatch()
  
  const {data} = useGetSingleByAgeAndGenderQuery(id)
  
  useEffect(()=>{
    async function fetchClass(){
      if(data){
         const dataObject = data?.data?.selectClass[0]
        setResData({...dataObject})
        dispatch(detailsEnroll(JSON.stringify(dataObject)))
      }else{
        setErrMsg(data?.error?.data?.message)
      }
    }
    fetchClass()
  },[data,dispatch])

  return (
    <div className='portal-kiga-details-main'>
      <Navbar/>
    <section className='portal-kiga-details-section'>
     <div className='portal-kiga-details-section-big-title'> 
      <p>{resData?.name}</p>
     </div>
     <div className='portal-kiga-details-section-button'>
      <Link to='/portal/booking/classes/add-student' >Enroll Now</Link>
     </div>
     <div className='portal-kiga-details-section-subtitle'>
       <p>Available for Mr,Mrs</p>
     </div>
       <div className='portal-kiga-details-section-info-title'>
         <p>Details</p>
       </div>
       <div className='portal-kiga-details-section-info-details-container'>
       <div className='portal-kiga-details-section-info-details-flex'>
         <div className='portal-kiga-details-section-info-details-schedule-flex'>
          <p><strong>Schedule:</strong></p>
          <p>{resData?.date}</p>
         </div>
         <div className='portal-kiga-details-section-info-details-program-flex'>
           <p><strong>Program:</strong></p>
           <p>{resData?.name}</p>
         </div>
         <div className='portal-kiga-details-section-info-details-level-flex'>
          <p><strong>Level:</strong></p>
          <p>Beginner</p>
         </div>
        </div>
        <div className='portal-kiga-details-section-info-description-small-title'>
          <p><strong>Description</strong></p>
        </div>
        <div className='portal-kiga-details-section-info-description-big-title'>
          <p><strong>{resData?.name}</strong></p>
        </div>
        <div className='portal-kiga-details-section-info-description-para'>
          <p>{resData?.description}</p>
        </div>
       </div>
    </section>
    </div>
  )
}

export default DetailEnroll